/**
 * Frontend display-label overrides for backend category names. The
 * backend canonical name stays as-is (so Mixpanel + analytics keep
 * a consistent label) — this is purely cosmetic.
 *
 * Today: "Bank" → "Finance".
 */
const DISPLAY_OVERRIDES: Record<string, string> = {
  bank: 'Finance',
};

type CategoryLike = { name?: string; slug?: string };

export const getCategoryDisplayName = (category: CategoryLike): string => {
  if (!category) return '';
  if (category.slug && DISPLAY_OVERRIDES[category.slug]) {
    return DISPLAY_OVERRIDES[category.slug];
  }
  return category.name || '';
};

/** Returns the same shape with `name` replaced where an override applies. */
export const applyCategoryDisplayOverrides = <T extends CategoryLike>(category: T): T => {
  if (!category?.slug || !DISPLAY_OVERRIDES[category.slug]) return category;
  return { ...category, name: DISPLAY_OVERRIDES[category.slug] };
};

/** Maps an array of category-like records, applying display overrides. */
export const mapCategoryDisplayOverrides = <T extends CategoryLike>(items: T[]): T[] => (
  items.map(applyCategoryDisplayOverrides)
);
